module.exports = __webpack_public_path__ + "img/SKMJ_heavy5.f91c92d3.png";